/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RilascioBudgetRevoca } from './rilascio-budget-revoca';
import { GraduatoriaScorrimentoPianoDTO } from './graduatoria-scorrimento-piano-dto';


export interface GraduatoriaScorrimentoStatoDTO { 
    abilitato?: boolean;
    rilascio_budget_revoca?: RilascioBudgetRevoca;
    eseguibile?: boolean;
    motivo_non_eseguibile?: string;
    /**
     * Budget liberato dalle revoche attive del bando, in totale
     */
    liberato_importo?: number;
    /**
     * Budget liberato gia\' usato da scorrimenti precedenti
     */
    usato_importo?: number;
    /**
     * Budget disponibile adesso; assente se il bando non ha budget
     */
    disponibile_importo?: number;
    /**
     * Posti disponibili adesso; assenti se il bando non ha un tetto di beneficiari
     */
    disponibile_posti?: number;
    /**
     * Importo che l\'esecuzione utilizzerebbe
     */
    importo_da_utilizzare?: number;
    posti_da_utilizzare?: number;
    /**
     * Per graduatoria, le righe che verrebbero finanziate
     */
    piano?: Array<GraduatoriaScorrimentoPianoDTO>;
}



